import { DatePicker, Select, Space } from 'antd';
import { useAppSelector } from 'app/hooks';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { selectColorList } from 'features/Inverter/inverterSlice';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
export default function DeviceLineChart(props) {
  const { optionSelect, dataChart, fetchDataInverterChart } = props;
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const listColor = useAppSelector(selectColorList);
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [valueDefault, setValueDefault] = useState();
  const [listOption, setListOption] = useState([]);

  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (inverterId) {
      setDate(moment().format('YYYY-MM-DD'));
    }
  }, [inverterId]);

  useEffect(() => {
    if (optionSelect) {
      setFilteredOptions(optionSelect);
      setSelectedItems([optionSelect[7].key]);
      setValueDefault(optionSelect[7].unit);
      setListOption([optionSelect[7].label]);
    }
  }, [optionSelect]);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(dataChart, selectedItems);
    }
  }, [dataChart]);

  const installDataset = (listOne, listTwo) => {
    let newList = [];
    for (let i = 0; i < listTwo.length; i++) {
      let newItem = {
        unit: valueDefault,
        type: 'line',
        label: listOption[i],
        data: listOne[listTwo[i]],
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        borderColor: listColor[i],
        borderWidth: 1,
        backgroundColor: listColor[i],
      };
      newList = [...newList, newItem];
    }
    return newList;
  };

  const updateDataset = (listOne, listTwo) => {
    chartInstance.data.datasets = installDataset(listOne, listTwo);
    chartInstance.options.scales.y.title.text = valueDefault;
    chartInstance.options.scales.y.ticks.callback = function (value, index, values) {
      return `${value} ${valueDefault}`;
    };
    chartInstance.update();
  };

  const data = {
    datasets: [
      {
        unit: valueDefault,
        type: 'line',
        label: 'value',
        data: dataChart,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        borderColor: '#038cfc',
        borderWidth: 1,
        backgroundColor: '#038cfc',
        fill: true,
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      elements: {
        point: {
          radius: 0,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      maintainAspectRatio: false,
      plugins: {
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        legend: {
          display: true,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            color: '#911',
            font: {
              family: 'Times',
              size: 20,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
        },
        y: {
          title: {
            display: false,
            text: valueDefault,
            color: '#191',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          ticks: {
            callback: function (value, index, values) {
              return `${value} ${valueDefault}`;
            },
          },
        },
      },
    },
  };

  const handleChangeSelect = (e) => {
    if (e.length === 1) {
      const newValue = filteredOptions.filter((item) => {
        return item.key === e[0];
      });
      setValueDefault(newValue[0].unit);
    } else if (e.length === 0) {
      setValueDefault('');
    }
    setSelectedItems(e);
    setListOption(updateListOption(filteredOptions, e));
    fetchDataInverterChart(e, date, optionSelect);
  };
  const onChangeDatePicker = (date, dateString) => {
    setDate(dateString);
    fetchDataInverterChart(selectedItems, dateString, optionSelect);
  };

  const updateListOption = (listOne, listTwo) => {
    let newList = [];
    listOne.forEach((itemOne) => {
      listTwo.forEach((itemTwo) => {
        if (itemOne.key === itemTwo) {
          newList = [...newList, itemOne.label];
        }
      });
    });
    return newList;
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  return (
    <div className="chart-device-one">
      <div
        className="header-chart"
        style={{
          height: '60px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 20px',
          borderBottom: '1px solid #EAEAEA',
        }}
      >
        <DatePicker
          disabledDate={disabledDate}
          picker="date"
          value={moment(date)}
          onChange={onChangeDatePicker}
        />
        <div
          style={{
            width: '40%',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Space
            direction="vertical"
            style={{
              width: '100%',
              paddingRight: '10px',
            }}
          >
            <Select
              mode="multiple"
              placeholder="Inserted are removed"
              value={selectedItems}
              onChange={(e) => handleChangeSelect(e)}
              style={{ width: '100%' }}
              maxTagCount="responsive"
            >
              {valueDefault !== ''
                ? filteredOptions.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item.key}
                      disabled={!(item.unit === valueDefault) ? true : false}
                    >
                      {item.label}
                    </Select.Option>
                  ))
                : filteredOptions.map((item, index) => (
                    <Select.Option key={index} value={item.key}>
                      {item.label}
                    </Select.Option>
                  ))}
            </Select>
          </Space>
        </div>
      </div>
      <div style={{ width: '100%', height: '360px', padding: '20px' }}>
        <canvas ref={chartRef} />
      </div>
    </div>
  );
}
